<div class="translations-admin">
    <mat-card>
        <mat-card-header>
            <mat-card-title>Gestion des Traductions</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div *ngIf="error" class="error-message">
                <mat-error>{{ error }}</mat-error>
            </div>

            <div *ngIf="updateSuccess" class="success-message">
                <div class="mat-caption-success">{{ updateMessage }}</div>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="20px" class="status-section">
                <div fxFlex="70" fxFlex.lt-md="100">
                    <h3 class="mat-h2">Statut des traductions</h3>

                    <div *ngIf="loading" class="loading-spinner">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>

                    <div *ngIf="!loading && translationStatus">
                        <!--<div class="mb-3">
                            <span class="mat-body-strong">Dernière mise à jour:</span>
                            <span class="mat-body">{{ formatDate(translationStatus.lastUpdated) }}</span>
                        </div>-->

                        <div class="mb-3">
                            <span class="mat-body-strong">Langues disponibles:</span>
                            <mat-chip-listbox>
                                <mat-chip *ngFor="let lang of translationStatus.languages" color="primary" selected>
                                    {{ lang }}
                                </mat-chip>
                            </mat-chip-listbox>
                            <div *ngIf="translationStatus.languages.length === 0" class="mat-caption">
                                Aucune langue trouvée
                            </div>
                        </div>
                    </div>

                    <mat-card *ngIf="!loading && !translationStatus" class="warning-card">
                        <mat-card-content>
                            <mat-icon>warning</mat-icon> Aucune information de traduction disponible
                        </mat-card-content>
                    </mat-card>
                </div>

                <div fxFlex="30" fxFlex.lt-md="100">
                    <mat-card class="actions-card">
                        <mat-card-content>
                            <button
                                    mat-raised-button
                                    color="primary"
                                    class="full-width-button"
                                    [disabled]="updating"
                                    (click)="updateTranslations()">
                                <mat-spinner *ngIf="updating" diameter="20" class="button-spinner"></mat-spinner>
                                <span>Mettre à jour les traductions</span>
                            </button>

                            <div class="mat-caption hint-text">
                                <p>Cette action téléchargera les dernières traductions depuis Lokalise et les appliquera au site.</p>
                                <!--<p>Dernière mise à jour: {{ formatDate(translationStatus?.lastUpdated || 'unknown') }}</p>-->
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <mat-divider class="section-divider"></mat-divider>

            <div class="help-section">
                <h3 class="mat-h2">Aide</h3>
                <p class="mat-body">Les traductions sont gérées dans Lokalise et peuvent être mises à jour manuellement à l'aide du bouton ci-dessus.</p>
                <p class="mat-body">Workflow recommandé:</p>
                <ol class="mat-body">
                    <li>Modifier les traductions dans <a href="https://app.lokalise.com" target="_blank" mat-button color="primary">Lokalise</a></li>
                    <li>Cliquer sur "Mettre à jour les traductions" pour les appliquer à l'application</li>
                </ol>

                <mat-card class="info-card">
                    <mat-card-content>
                        <mat-icon>info</mat-icon>
                        <span class="mat-body-strong">Note:</span> La mise à jour des traductions n'affecte que l'environnement actuel.
                        Chaque environnement (développement, test, production) doit être mis à jour séparément.
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
</div>
